import axios from "axios";
import helpers from './helpers';

export default {
    // eslint-disable-next-line no-unused-vars
    getRoleCategories({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/role/category`)
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    getAdministrators({commit}, data) {
        commit('setBusy', true);

        axios.get(`/api/user?limit=${data.params.limit}&offset=${data.params.offset}${helpers.createFilterQuery(data.filters)}${data.sort}`)
            .then(response => {
                commit('setAdministrators', response.data.items);
                commit('setTotalCounts', response.data.totalCount);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getAdministratorDetails({commit}, id) {
        axios.get(`/api/user/${id}`)
            .then(response => {
                commit('setAdministrator', response.data);
                commit('setAdministratorDataIsLoading', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getRoles({commit}) {
        axios.get('/api/role?limit=20000')
            .then(response => {
                commit('setRoles', response.data.items);
            }).catch(error => {
            console.log(error);
        });
    },
    getGroups({commit}) {
        axios.get('/api/group')
            .then(response => {
                commit('setGroups', response.data.items);
            }).catch(error => {
            console.log(error);
        });
    },
    setAdministratorRole({state}, data) {
        const administratorId = state.administratorDetails.id.uuid;

        return axios.put(`/api/user/${administratorId}/role`, data);
    },
    setAdministratorGroup({state}, data) {
        const administratorId = state.administratorDetails ? state.administratorDetails.id.uuid : null;

        return axios.put(`/api/user/${administratorId}/group`, data);
    },
    setAdministratorData({state}, data) {
        const administratorId = state.administratorDetails ? state.administratorDetails.id.uuid : null;
        const method = administratorId ? 'put' : 'post';
        const url = administratorId ? `/api/user/${state.administratorDetails.id.uuid}` : 'api/user';

        return axios({url: url, method: method, data: data});
    },
    setAdministratorPassword({state}, data) {
        const url = `/api/user/${state.administratorDetails.id.uuid}/password`;

        return axios({url: url, method: 'post', data: data});
    },
    getAdministratorDetailsGroupsWithRoles({state, commit}) {
        const groupsId = state.administratorDetails.groups.map(group => {
            return group.id;
        });

        let promises = [];

        groupsId.forEach(id => {
            const promise = axios.get(`/api/group/${id}`);
            promises.push(promise);
        });

        Promise.all(promises).then(response => {
            const groups = [];
            response.forEach(element => {
                groups.push(element.data.item);
            });
            commit('setAdministratorDetailsGroupsWithRoles', groups);
        });
    },
    getTenants({commit}) {
        axios.get(`/api/tenant/tenant/list`)
            .then(response => {
                commit('setTenants', response.data.items);
            })
            .catch(error => {
                console.log(error);
            });
    },
}
